import { BaseRequest } from '../store/models'
import { insightsApi, type InsightsDataApiResponse } from '../shared/insights/store/insights'
import { INSIGHTS_CACHE_TTL_SECONDS } from '../shared/insights/utils/insightsUtils'

export interface InsightsDataRequest extends BaseRequest {
  from: string
  to: string
  userIdList?: string[]
}

interface AdvisorInsightsDataRequest extends BaseRequest {
  from: string
  to: string
  meetingTemplateId?: string
}

const insightsDataApi = insightsApi.injectEndpoints({
  endpoints: (builder) => ({
    getInsightsData: builder.query<InsightsDataApiResponse, InsightsDataRequest>({
      query: ({ accountId, from, to, userIdList }) => ({
        url: `/v1/accounts/${accountId}/insights/query`,
        method: 'POST',
        body: {
          from,
          to,
          ...(userIdList?.length ? { userIdList } : {}),
        },
      }),
      transformResponse: (response: { data?: InsightsDataApiResponse } & InsightsDataApiResponse) => response.data ?? response,
      keepUnusedDataFor: INSIGHTS_CACHE_TTL_SECONDS,
    }),
    getAdvisorInsightsData: builder.query<InsightsDataApiResponse, AdvisorInsightsDataRequest>({
      query: ({ accountId, from, to, meetingTemplateId }) => ({
        url: `/v1/accounts/${accountId}/insights/advisor-query`,
        method: 'GET',
        params: { from, to, ...(meetingTemplateId ? { meetingTemplateId } : {}) },
      }),
      transformResponse: (response: { data?: InsightsDataApiResponse } & InsightsDataApiResponse) => response.data ?? response,
      keepUnusedDataFor: INSIGHTS_CACHE_TTL_SECONDS,
    }),
  }),
})

export const { useGetInsightsDataQuery, useGetAdvisorInsightsDataQuery } = insightsDataApi
